// extracted by mini-css-extract-plugin
export var black = "Choice-module--black--2t5WJ";
export var group = "Choice-module--group--SleNr";
export var item = "Choice-module--item--rdALX";
export var label = "Choice-module--label--esx00";
export var root = "Choice-module--root--69GnH";
export var white = "Choice-module--white--7UUBh";